import { UserRights } from '../flights/interop/user-rights';
import { AircraftThresholdType, AirportThresholdType } from './thresholds';

export enum AirportIdDisplayStyleEnum {
    iata,
    icao,
    iataIcao,
    icaoIata
}

export enum FleetMonitorSortType {
    monitorStatusPriorityCallsignFlightStatus = 1,
    callsignFlightStatus = 2,
    flightStatusCallsign = 3,
    flightStatusDepartureTime = 4,
    departureTime = 5,
    eta = 6,
    distanceFromDestination = 7,
    departureTimeEta = 8,
    taxiTime = 9
}

export enum SortOrderEnum {
    asc,
    desc
}

export enum AirportMonitorSortType {
    monitorStatusPriorityId,
    id
}

export enum MapImageFormat {
    png,
    jpg,
    webp
}

export enum MapAutoScreenshotTarget {
    upload = 1,
    file = 2,
    all = 1 | 2
}

export enum EliDisplayModeEnum {
    newTab,
    newWindow
}

export interface EliCustomButton {
    label: string;
    urlTemplate: string;
    filter: string | null;
}

export enum MapUpdateMode {
    automatic,
    manual
}

export interface AircraftTypeRecord {
    acType: string | null;
    speed: number | null;
    fuelBurningRate: number | null;
    fuelReserve: number | null;
}

export interface BaseMapInfo {
    version: number;
    /** @format Date  */
    buildDate: string;
    urlToken: number;
}

export interface NavMapInfo {
    company: string;
    version: number;
    sequence: number;
    cycleDate: string;
    buildDate: string;
}

export interface FEWebSettingModel {
    // TODO
}

export enum WorkspaceLayout {
    single,
    dualVertical,
    dualHorizontal,
    triVertical,
    triHorizontal,
    quad
}

export interface WelcomeHelperSettings {
    text: string;
    fontSize: number;
    fontWeight: 'normal' | 'bold';
    textColor: string;
    scale: number;
    opacity: number;
    gap: number;
    position: string;
    offsetX: number;
    offsetY: number;
    svgContent: string | null;
    visible: boolean;
}

export const DEFAULT_WELCOME_HELPER: WelcomeHelperSettings = {
    text: 'Welcome',
    fontSize: 1.6,
    fontWeight: 'bold',
    textColor: '#ffffff',
    scale: 1.5,
    opacity: 0.85,
    gap: 8,
    position: 'bottom-right',
    offsetX: 0,
    offsetY: 0,
    svgContent: null,
    visible: false
};

export type UserRightsExtended = UserRights & { companyFeaturesEnabled: boolean };

export type MapTooltipSettings = {
    requireCtrlKey: boolean;
    /** Specifies which tooltips require CTRL  */
    items: {
        // If you add something here in the future make sure to use '?' in the definition
        // There may already be people who have this setting in the DB
        planes: boolean;
        weather: boolean;
        navData: boolean;
        other: boolean;
    };
};

export type DashboardWidgetSettings = {
    id: string;
    enabled: boolean;
    x: number;
    y: number;
    w: number;
    h: number;
};

export type CustomEmailAlert = {
    email: string;
    aircraftAlerts: AircraftThresholdType[];
    airportAlerts: AirportThresholdType[];
};

export enum EventListBackgroundColorMode {
    default,
    importantBackground,
    monitorStatusBackground
}
